export default __webpack_public_path__ + "static/media/skull.7c266059.svg";